import moment from "moment";
import Toast from "react-hot-toast";
import _ from "lodash";

const showToast = (
  msg,
  type = "success",
  visibilityTime = 3000,
  autoHide = true
) => {
  Toast.show({
    msg,
    type,
    visibilityTime,
    autoHide,
  });
};
const getUserData = (props) => {
  const { datastore, activePath } = props;

  if (datastore) {
    const dataset1 = JSON.parse(JSON.stringify(datastore));
    const datavalue = dataset1.data.user.config;
    const findvataset = Object.entries(datavalue).map(([key, value]) => {
      return [key, value];
    });
    const dataval = _.find(findvataset, (val) => {
      const slicepath = _.split(activePath, "/");
      const new_str = val[0].replace(/([^\w ]|_)/g, '');;
      return val === undefined ? null : new_str === slicepath[1];
    });

    return dataval;
  }
};

const dateFormate = (date, formate) => {
  if (formate) {
    return moment.utc(date).format(formate);
  }
  return moment.utc(date);
};

const Utility = {
  showToast,
  dateFormate,
  getUserData,
};

export default Utility;
